import { render, staticRenderFns } from "./SendTab.vue?vue&type=template&id=038598be&scoped=true&"
import script from "./SendTab.vue?vue&type=script&lang=ts&"
export * from "./SendTab.vue?vue&type=script&lang=ts&"
import style0 from "./SendTab.vue?vue&type=style&index=0&id=038598be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038598be",
  null
  
)

export default component.exports